import getReportHistoryData from './getReportHistoryData'
export const getReportHistoryDataService = getReportHistoryData;